import React, { useState, useEffect } from "react";
import { Plus, Pencil, Trash2, X, Save, Star } from "lucide-react";
import { api } from "../lib/api";

const empty = { text: "", name: "", role: "", rating: 5, order: 0 };

const TestimonialsManager = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const load = () => api.listTestimonials().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ ...empty, order: items.length + 1 }); setEditing("new"); };
  const openEdit = (it) => { setForm({ ...it }); setEditing(it.id); };
  const close = () => { setEditing(null); setForm(empty); };
  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...form, rating: Number(form.rating), order: Number(form.order) };
      if (editing === "new") await api.createTestimonial(payload);
      else await api.updateTestimonial(editing, payload);
      await load();
      close();
    } catch { alert("Erro ao guardar."); }
    finally { setSaving(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminar este testemunho?")) return;
    setItems((p) => p.filter((i) => i.id !== id));
    try { await api.deleteTestimonial(id); } catch { load(); }
  };

  const inputCls = "bf-input w-full rounded-xl px-4 py-2.5 text-sm placeholder:text-gray-500";
  const labelCls = "block text-xs font-medium text-gray-400 mb-1.5";

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <p className="text-gray-400 text-sm">{items.length} testemunho(s)</p>
        <button onClick={openNew} className="bf-btn-primary text-white font-semibold px-5 py-2.5 rounded-xl inline-flex items-center gap-2 text-sm">
          <Plus className="w-4 h-4" /> Novo Testemunho
        </button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((it) => (
          <div key={it.id} className="bf-glass rounded-2xl p-6">
            <div className="flex items-start justify-between mb-3">
              <div className="flex gap-0.5">
                {[...Array(it.rating || 5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" />)}
              </div>
              <div className="flex gap-2">
                <button onClick={() => openEdit(it)} className="p-2 rounded-lg bg-white/5 text-gray-300 hover:text-[#67e8f9] border border-white/10"><Pencil className="w-4 h-4" /></button>
                <button onClick={() => remove(it.id)} className="p-2 rounded-lg bg-red-500/10 text-red-400 border border-red-500/20"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <p className="text-gray-300 text-sm italic mb-3">"{it.text}"</p>
            <p className="text-white font-bold text-sm">{it.name}</p>
            <p className="text-[#67e8f9] text-xs">{it.role}</p>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-[70] bg-black/70 flex items-center justify-center p-4" onClick={close}>
          <div className="bf-glass rounded-2xl p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-white font-bold text-lg">{editing === "new" ? "Novo Testemunho" : "Editar Testemunho"}</h3>
              <button onClick={close} className="text-gray-400 hover:text-white"><X className="w-5 h-5" /></button>
            </div>
            <form onSubmit={save} className="space-y-4">
              <div>
                <label className={labelCls}>Texto *</label>
                <textarea name="text" required rows={3} value={form.text} onChange={onChange} className={inputCls} />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={labelCls}>Nome *</label>
                  <input name="name" required value={form.name} onChange={onChange} className={inputCls} />
                </div>
                <div>
                  <label className={labelCls}>Função</label>
                  <input name="role" value={form.role} onChange={onChange} className={inputCls} placeholder="Piloto MXGP" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={labelCls}>Estrelas</label>
                  <select name="rating" value={form.rating} onChange={onChange} className={inputCls}>
                    {[5, 4, 3, 2, 1].map((r) => <option key={r} value={r} className="bg-[#131b32]">{r}</option>)}
                  </select>
                </div>
                <div>
                  <label className={labelCls}>Ordem</label>
                  <input type="number" name="order" value={form.order} onChange={onChange} className={inputCls} />
                </div>
              </div>
              <button type="submit" disabled={saving} className="bf-btn-primary text-white font-semibold px-6 py-3 rounded-xl w-full inline-flex items-center justify-center gap-2 text-sm disabled:opacity-60">
                <Save className="w-4 h-4" /> {saving ? "A guardar..." : "Guardar"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestimonialsManager;
